// extracted by mini-css-extract-plugin
module.exports = {"row":"borrow_row__2iccJ","column":"borrow_column__1l5e4","buttonWrapper":"borrow_buttonWrapper__3ljFM"};